export default "__VITE_ASSET__CfOBqfqM__"